<template>
  <span class="notifyDot" :class="[kind, { overlay }]" aria-hidden="true"></span>
</template>

<script setup lang="ts">
// Gold "needs you" marker: filled = todo, border only = waiting on someone else.
// `overlay` pins it on a position:relative host's top-right corner; the host sets
// --notify-dot-cutout to its own background.
defineProps<{ kind: 'todo' | 'wait'; overlay?: boolean }>()
</script>

<style scoped>
.notifyDot {
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  border: 1.5px solid var(--hue-gold);
}
.notifyDot.todo { background: var(--hue-gold); }
.notifyDot.overlay {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  outline: 2px solid var(--notify-dot-cutout, var(--color-bg-surface));
}
</style>
